import { useId, type SVGAttributes } from "react";
import { cn } from "../helpers/class-names";

type MagnusOperaIconProps = SVGAttributes<SVGSVGElement> & { title?: string };

export function MagnusOperaIcon({
  className,
  title,
  ...props
}: MagnusOperaIconProps) {
  const id = useId().replaceAll(":", "");
  const warmGradient = `${id}-warm`;
  const coolGradient = `${id}-cool`;

  return (
    <svg
      className={cn("ui-brand-icon", className)}
      viewBox="0 0 758.993 567.004"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      {...props}
    >
      {title && <title>{title}</title>}
      <defs>
        <linearGradient
          id={warmGradient}
          gradientUnits="userSpaceOnUse"
          x1="818.3"
          y1="493.056"
          x2="1320.3"
          y2="493.056"
        >
          <stop offset="0" stopColor="#ff0080" />
          <stop offset="1" stopColor="#ff8000" />
        </linearGradient>
        <linearGradient
          id={coolGradient}
          gradientUnits="userSpaceOnUse"
          x1="561.3"
          y1="486.056"
          x2="1063.3"
          y2="486.056"
        >
          <stop offset="0" stopColor="#7a7ecf" />
          <stop offset="1" stopColor="#00bbff" />
        </linearGradient>
      </defs>
      <g transform="translate(-561.306 -206.057)">
        <path
          d="M1285.1 426.55 959.85 226.6c-60.34-37.09-137.71 6.34-138.32 77.65l-.25 28.96h40.53c8.77-46.75 64.28-72.81 108.33-46.79l257.52 152.11c37.16 22.44 37.16 74.91 0 97.35l-257.2 155.34c-48 28.99-109.74-3.24-112.3-57.01h-39.47l-.38 44.14c-.64 73.92 79.79 119.47 141.96 80.39l324.84-204.21c46.92-29.51 46.92-98.47-.01-127.98Z"
          fill={`url(#${warmGradient})`}
        />
        <path
          d="M1028.1 419.55 702.85 219.6c-60.34-37.09-137.71 6.34-138.32 77.65l-3.22 374.1c-.64 73.92 79.79 119.47 141.96 80.39l324.84-204.21c46.92-29.51 46.92-98.47-.01-127.98Zm-55 113.27L720.09 688.16c-48.42 29.73-111.06-4.92-110.57-61.15l2.51-284.58c.48-54.24 60.74-87.29 107.74-59.07L973.1 435.47c36.56 22.44 36.56 74.9 0 97.35Z"
          fill={`url(#${coolGradient})`}
        />
      </g>
    </svg>
  );
}
